@if (open) {
<!-- Static Backdrop -->
@if (mode === 'overlay') {
<div class="fixed right-0 bottom-0 z-[998] bg-black/50 transition-opacity duration-300" [ngClass]="backdropBlurClass"
  style="top: var(--navbar-height, 0px); left: var(--sidebar-width, 0px);"></div>
}

<!-- Sliding Panel Container -->
<div
  [ngClass]="
    mode === 'overlay'
      ? 'fixed bottom-0 right-0 w-full max-w-md z-[9999] pointer-events-none flex justify-end'
      : 'relative w-full h-full flex justify-end overflow-hidden'
  "
  [style.top]="mode === 'overlay' ? 'var(--navbar-height, 0px)' : null"
  class="{{ containerClass }}"
  @slideInOut
>  
<div
    [ngClass]="
      mode === 'overlay'
        ? 'bg-white dark:bg-slate-900 shadow-2xl w-full pointer-events-auto'
        : 'pointer-events-auto'
    "
    class="h-full flex flex-col transition-colors duration-300 text-slate-900 dark:text-white {{
      panelClass
    }}"
    appClickOutside
    (appClickOutside)="outsideClick ? hide() : null"
  >
    @if (title || showClose) {
    <div
      class="flex items-center justify-between px-6 py-4 border-b border-[#EAEAEA] dark:border-line dark:text-white text-slate-700 {{ headerClass }}"
    >
      <div class="flex items-center gap-3">
        @if (titleIcon) {
        <app-icon [name]="titleIcon" [size]="24"></app-icon>
        }
        @if (title) {
        <h2 class="text-xl font-bold tracking-tight">{{ title }}</h2>
        }
      </div>
      <div class="flex items-center gap-6">
        @if(showCopyIcon){
        <button
          class="flex items-center gap-2 cursor-pointer text-purple-500 hover:text-purple-700 dark:text-purple-300 dark:hover:text-white"
          (click)="copyEntirePrompt()"
        >
          Copy prompt <app-icon [name]="'copy'" [size]="20"></app-icon>
        </button>
        } @if (showClose) {
        <button
          (click)="hide()"
          class="px-2 cursor-pointer rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-xl"
        >
          &times;
        </button>
        }
      </div>
    </div>
    }
    <div class="flex-1 overflow-y-auto {{ contentClass }}">
      <ng-content></ng-content>
    </div>
  </div>
</div>
}
